import { FormSwitch } from "@farzoom/common-ui-components";
import { Space, Typography } from "antd";
import { useFormContext } from "react-hook-form";
import { createUseStyles } from "react-jss";
import { LotsSubComponent } from "./lots";
import { ContractExecutionConditions } from "./contractExecutionConditions";
import { BgFormInput } from "@utils/guaranteeForm/formShema";
import { useBgFormContext } from "@app/guranteeFormWrapper";
import { VerticalSpace } from "@app/UI/VerticalSpace";

const { Text } = Typography;

const useStyles = createUseStyles({
  switch: {
    "& [class*=baseInput] .ant-switch": {
      width: "60px",
    },
  },
});

export const ContractConditions = ({ lotIndex }: LotsSubComponent) => {
  const classes = useStyles();
  const { control } = useFormContext<BgFormInput>();
  const { prefix } = useBgFormContext();

  const currentPrefix = (prefix ? `${prefix}.purchase.lots` : "purchase.lots") as "purchase.lots";

  return (
    <VerticalSpace>
      <Text strong>Условия контракта</Text>
      <VerticalSpace>
        <Space>
          <FormSwitch
            label="Бесспорное списание"
            className={classes.switch}
            name={`${currentPrefix}.${lotIndex}.contractConditions.requiredIndisputableDebiting`}
            control={control}
            checkedLabel=""
            uncheckedLabel=""
          />
        </Space>

        <ContractExecutionConditions lotIndex={lotIndex} />
      </VerticalSpace>
    </VerticalSpace>
  );
};
